import slide1 from "@/assets/optimized-images/whyMaqrah.jpg";
import slide2 from "@/assets/optimized-images/what_maqrahat.jpg";
import slide3 from "@/assets/optimized-images/wedo.jpg";
import slide4 from "@/assets/optimized-images/Vision_mission.jpg";
import slide5 from "@/assets/optimized-images/serving.jpg";
import slide6 from "@/assets/optimized-images/Aboutus.jpg";
import slide7 from "@/assets/optimized-images/adultclass.jpg";
import slide8 from "@/assets/optimized-images/chooseus.jpg";
import slide9 from "@/assets/optimized-images/corevalue.jpg";
import slide10 from "@/assets/optimized-images/courses.jpg";
import slide11 from "@/assets/optimized-images/tanzeelijaza.jpg";
import slide12 from "@/assets/optimized-images/firstClass.jpg";
import slide13 from "@/assets/optimized-images/foundation.jpg";
import slide14 from "@/assets/optimized-images/join_program.jpg";
import slide15 from "@/assets/optimized-images/language.jpg";
import slide16 from "@/assets/optimized-images/online.jpg";
import slide17 from "@/assets/optimized-images/pricing.jpg";
import slide18 from "@/assets/optimized-images/offer.jpg";
import slide19 from "@/assets/optimized-images/maqraah.jpg";
import slide20 from "@/assets/optimized-images/maqraah.jpg";
import yusuf from "@/assets/optimized-images/yusuf.png";
import egba from "@/assets/optimized-images/Egba.png";
import ajeen from "@/assets/optimized-images/ajeen.png";
import tanzeelijaza from "@/assets/optimized-images/tanzeelijaza.jpg";
import tanzeelijaza2 from "@/assets/optimized-images/tanzeelijaza2.jpg";
import tanzeelijaza3 from "@/assets/optimized-images/tanzeelijaza3.jpg";
import tanzeelijaza4 from "@/assets/optimized-images/tanzeelijaza4.jpg";
import tanzeelijaza5 from "@/assets/optimized-images/tanzeelijaza5.jpg";
import tanzeelijaza6 from "@/assets/optimized-images/tanzeelijaza6.jpg";
import tanzeelijaza7 from "@/assets/optimized-images/tanzeelijaza7.jpg";
import tanzeelijaza8 from "@/assets/optimized-images/tanzeelijaza8.jpg";
import tanzeelijaza9 from "@/assets/optimized-images/tanzeelijaza9.jpg";
import tanzeelijaza10 from "@/assets/optimized-images/tanzeelijaza10.jpg";
import tanzeelijaza11 from "@/assets/optimized-images/tanzeelijaza11.jpg";
import tanzeelijaza12 from "@/assets/optimized-images/tanzeelijaza12.jpg";
import tanzeelijaza13 from "@/assets/optimized-images/tanzeelijaza13.jpg";
import tanzeelijaza14 from "@/assets/optimized-images/tanzeelijaza14.jpg";
import tanzeelijaza15 from "@/assets/optimized-images/tanzeelijaza15.jpg";
import tanzeelijaza16 from "@/assets/optimized-images/tanzeelijaza16.jpg";

import qolun_nafi from "@/assets/optimized-images/qirahat/qolun_nafi.jpg";
import warsh_nafi from "@/assets/optimized-images/qirahat/warsh_nafi.jpg";
import ibn_kasirr from "@/assets/optimized-images/qirahat/ibn_kasirr.jpg";
import doori from "@/assets/optimized-images/qirahat/doori_abu_amr.jpg";
import soosi_abu_amr from "@/assets/optimized-images/qirahat/soosi_abu_amr.jpg";
import ibn_Aamirr from "@/assets/optimized-images/qirahat/ibn_Aamirr.jpg";
import shubah_asimm from "@/assets/optimized-images/qirahat/shubah_asimm.jpg";
import hamzahh from "@/assets/optimized-images/qirahat/hamzah.jpg";
import kisahii from "@/assets/optimized-images/qirahat/kisahii.jpg";
import jafar from "@/assets/optimized-images/qirahat/Abu_jafar.jpg";
import yaakuub from "@/assets/optimized-images/qirahat/yaakub.jpg";
import khalaf_ashirr from "@/assets/optimized-images/qirahat/khalaf_ashirr.jpg";
import Qohidat_Nour_El_Bayan from "@/assets/optimized-images/Books/Qohidat_Nour_El_Bayan.jpg";

import content from "@/assets/optimized-images/content/content.jpg";
import content1 from "@/assets/optimized-images/content/content1.jpg";
import content2 from "@/assets/optimized-images/content/content2.jpg";
import content3 from "@/assets/optimized-images/content/content3.jpg";
import content4 from "@/assets/optimized-images/content/content4.jpg";
import content5 from "@/assets/optimized-images/content/content5.jpg";
import content6 from "@/assets/optimized-images/content/content6.jpg";
import content7 from "@/assets/optimized-images/content/content7.jpg";
import content8 from "@/assets/optimized-images/content/content8.jpg";
import content9 from "@/assets/optimized-images/content/content9.jpg";
import content10 from "@/assets/optimized-images/content/content.jpg";
import content11 from "@/assets/optimized-images/content/content.jpg";

import Quran_warsh_nafiu from "@/assets/optimized-images/Quran/Quran_warsh_nafiu.jpg";
import Quran_qolun_Nafiu from "@/assets/optimized-images/Quran/Quran_qolun_Nafi.jpg";
import Quran_ibn_kasirr from "@/assets/optimized-images/Quran/Quran_ibn_kasir.jpg";

import Quran_Abu_amr from "@/assets/optimized-images/Quran/Quran_Abu_Amr.jpg";
import Quran_doori_abu_amr from "@/assets/optimized-images/Quran/Quran_doori_abu_amr.jpg";
import Quran_soosi_abu_Amrr from "@/assets/optimized-images/Quran/Quran_soosi_abu_Amr.jpg";
import Quran_ibn_Amir from "@/assets/optimized-images/Quran/Quran_Ibn_Amir.jpg";
import Quran_hisham_ibn_Amir from "@/assets/optimized-images/Quran/Quran_hisham_ibn_Aamir.jpg";
import Quran_ibn_zakwan_ibn_aamir from "@/assets/optimized-images/Quran/Quran_ibn_zakwan_ibn_aamir.jpg";
import Quran_asim from "@/assets/optimized-images/Quran/Quran_asim.jpg";
import Quran_shubah_asimm from "@/assets/optimized-images/Quran/Quran_shubah_asim.jpg";
import Quran_hafs_aasim from "@/assets/optimized-images/Quran/Quran_Hafs_aasim.jpg";
import Quran_Hamzat from "@/assets/optimized-images/Quran/Quran_Hamzat.jpg";
import Quran_khalaf_hamzahh from "@/assets/optimized-images/Quran/Quran_khalaf_hamzah.jpg";
import quran_khalad_hamzah from "@/assets/optimized-images/Quran/quran_khalad_hamzah.jpg";
import Quran_kisahii from "@/assets/optimized-images/Quran/Quran_kisahi.jpg";
import Quran_jafar from "@/assets/optimized-images/Quran/Quran_Abu_jafar.jpg";
import Quran_yaakuub from "@/assets/optimized-images/Quran/Quran_yaakub.jpg";
import Quran_khalaf_ashir from "@/assets/optimized-images/Quran/Quran_khalaf_ashir.jpg";

// import { academyPath } from "../routes/path";

const slides = [
  { id: 1, image: slide1 },
  { id: 2, image: slide2 },
  { id: 3, image: slide3 },
  { id: 4, image: slide4 },
  { id: 5, image: slide5 },
  { id: 6, image: slide6 },
  { id: 7, image: slide7 },
  { id: 8, image: slide8 },
  { id: 9, image: slide9 },
  { id: 10, image: slide10 },
  { id: 11, image: slide11 },
  { id: 12, image: slide12 },
  { id: 13, image: slide13 },
  { id: 14, image: slide14 },
  { id: 15, image: slide15 },
  { id: 16, image: slide16 },
  { id: 17, image: slide17 },
  { id: 18, image: slide18 },
  { id: 19, image: slide19 },
  { id: 20, image: slide20 },
];

const awards = [
  { id: 1, image: tanzeelijaza },
  { id: 2, image: tanzeelijaza2 },
  { id: 3, image: tanzeelijaza3 },
  { id: 4, image: tanzeelijaza4 },
  { id: 5, image: tanzeelijaza5 },
  { id: 6, image: tanzeelijaza6 },
  { id: 7, image: tanzeelijaza7 },
  { id: 8, image: tanzeelijaza8 },
  { id: 9, image: tanzeelijaza9 },
  { id: 10, image: tanzeelijaza10 },
  { id: 11, image: tanzeelijaza11 },
  { id: 12, image: tanzeelijaza12 },
  { id: 13, image: tanzeelijaza13 },
  { id: 14, image: tanzeelijaza14 },
  { id: 15, image: tanzeelijaza15 },
  { id: 16, image: tanzeelijaza16 },
];
const contents = [
  { id: 1, image: content },
  { id: 2, image: content1 },
  { id: 3, image: content2 },
  { id: 4, image: content3 },
  { id: 5, image: content4 },
  { id: 6, image: content5 },
  { id: 7, image: content6 },
  { id: 8, image: content7 },
  { id: 9, image: content8 },
  { id: 10, image: content9 },
  { id: 11, image: content10 },
  { id: 12, image: content11 },
];

const instructors = [
  {
    id: 1,
    image: egba,
    name: "Muqri. Abdul Qudus Jumah",
    ocupation: "Qori & Muqri",
  },
  {
    id: 2,
    image: yusuf,
    name: " Hafiz Tajudeen Yusuf",
    ocupation: "Hafiz",
  },
  {
    id: 3,
    image: ajeen,
    name: "Hafz Abdullahi Sulaimon",
    ocupation: "Hafiz",
  },
];

const curriculums = [
  {
    id: 1,
    show: false,
    outerText: "Intro Video: Introduction",
    innerText: "Opening Conclave",
  },
  {
    id: 2,
    show: false,
    outerText: "Strategy 1 - 50",
    innerText: "Opening Conclave",
  },
  {
    id: 3,
    show: false,
    outerText: "Outro Videos: Final Word",
    innerText: "Outro & Closing Conclave: Final Words",
  },
];

const cardInfos = [
  {
    id: 1,
    bookImage: Quran_warsh_nafiu,
    bookCaterory: "QUR'AN",
    bookTitle: "Qur'an - Qirā’at Nafi",
    lessonNumber: "9",
    bookStudent: "432",
    bookPrice: 3000,
    ratings: 4.9,
    pdfUrl: "Quran_warsh_Nafi",
    fileName: ".pdf",
    curriculums: [
      {
        id: 1,
        show: false,
        outerText: "Intro Video: Introduction",
        innerText: [
          "Lesson 1:",
          "Lesson 2: ",
          "Lesson 3: ",
          "Lesson 4: ",
          "Bonus 1: ",
          "Bonus 2: ",
          "Bonus 3: ",
          "Bonus 4:",
          "Bonus 5: ",
        ],
      },
    ],
  },
  {
    id: 2,
    bookImage: Quran_warsh_nafiu,
    bookCaterory: "QUR'AN",
    bookTitle: "Qur'an - Riwaayah Warsh",
    lessonNumber: "9",
    bookStudent: "432",
    bookPrice: 2000,
    ratings: 4.9,
    pdfUrl: "Quran_warsh_Nafi",
    fileName: ".pdf",
    curriculums: [
      {
        id: 1,
        show: false,
        outerText: "Intro Video: Introduction",
        innerText: [
          "Lesson 1:",
          "Lesson 2: ",
          "Lesson 3: ",
          "Lesson 4: ",
          "Bonus 1: ",
          "Bonus 2: ",
          "Bonus 3: ",
          "Bonus 4:",
          "Bonus 5: ",
        ],
      },
    ],
  },
  {
    id: 3,
    bookImage: Quran_qolun_Nafiu,
    bookCaterory: "QUR'AN",
    bookTitle: "Qur'an - Riwaayah Qaloon",
    lessonNumber: "8",
    bookStudent: "291",
    bookPrice: 2000,
    ratings: 4.9,
    pdfUrl: "Quran_qolun_Nafi",
    fileName: ".pdf",
    curriculums: [
      {
        id: 1,
        show: false,
        outerText: "Intro Video: Introduction",
        innerText: [
          "Lesson 1: ",
          "Lesson 1: ",
          "Lesson 2: ",
          "Lesson 3: How to reserve a name",
          "Lesson 4: Company Registration.",
          "Bonus 1: ",
          "Bonus 2:",
          "Bonus 3: ",
          "Bonus 4: How to do name substitution",
        ],
      },
    ],
  },
  {
    id: 4,
    bookImage: Quran_ibn_kasirr,
    bookCaterory: "QUR'AN",
    bookTitle: "Qur'an - Qirā’at Ibn Katheer al-Makki",
    lessonNumber: "10",
    bookStudent: "302",
    bookPrice: 3000,
    ratings: 4.5,
    pdfUrl: "Quran_ibn_kasir",
    fileName: ".pdf",
    curriculums: [
      {
        id: 1,
        show: false,
        outerText: "Intro Video: Introduction",
        innerText: [
          "See First: ",
          "Lesson 1: ",
          "Lesson 1: ",
          "Lesson 2: ",
          "Lesson 3:",
          "Lesson 4:",
          "Bonus 1: ",
          "Bonus 2:",
          "Bonus 3: ",
          "Bonus 4: ",
          "Bonus 5: ",
        ],
      },
    ],
  },

  {
    id: 5,
    bookImage: Quran_Abu_amr,
    bookCaterory: "QUR'AN",
    bookTitle: "Qur'an - Qirā’at Abu Amr",
    lessonNumber: "48",
    bookStudent: "",
    bookPrice: 3000,
    ratings: 4.1,
    pdfUrl: "Quran_Abu_Amr",
    fileName: ".pdf",
    curriculums: [
      {
        id: 1,
        show: false,
        outerText: "ACCESS TO AGENT PORTAL",
        innerText: ["Introduction"],
      },
      {
        id: 2,
        show: false,
        outerText: "QUR'AN",
        innerText: [],
      },
    ],
  },
  {
    id: 6,
    bookImage: Quran_doori_abu_amr,
    bookCaterory: "QUR'AN",
    bookTitle: "Qur'an - Riwaayah Al-Doori",
    lessonNumber: "48",
    bookStudent: "",
    bookPrice: 2000,
    ratings: 4.1,
    pdfUrl: "Quran_Doorii_Abu_Amr",
    fileName: ".pdf",
    curriculums: [
      {
        id: 1,
        show: false,
        outerText: "ACCESS TO AGENT PORTAL",
        innerText: ["Introduction"],
      },
      {
        id: 2,
        show: false,
        outerText: "QUR'AN",
        innerText: [""],
      },
      {
        id: 3,
        show: false,
        outerText: "QUR'AN",
        innerText: [""],
      },
      {
        id: 4,
        show: false,
        outerText: "QUR'AN",
        innerText: ["", ""],
      },
    ],
  },
  {
    id: 7,
    bookImage: Quran_soosi_abu_Amrr,
    bookCaterory: "QUR'AN",
    bookTitle: "Qur'an - Riwaayah As-Sousi",
    lessonNumber: "7",
    bookStudent: "200",
    bookPrice: 2000,
    ratings: 4.2,
    pdfUrl: "Quran_soosi_Abu_Amr",
    fileName: ".pdf",
    curriculums: [
      {
        id: 1,
        show: false,
        outerText: "STAGE 1: THIS APPLY TO BOTH",
        innerText: ["Lesson 1: ", "Lesson 1: ", "Lesson 2: "],
      },
      {
        id: 2,
        show: false,
        outerText: "IGROUP OF COMPANY REGISTRATION",
        innerText: ["Read Me: ", "Lesson 1: ", "Lesson 2: "],
      },
      {
        id: 3,
        show: false,
        outerText: "",
        innerText: ["Lesson 1: ", "Lesson 2: "],
      },
    ],
  },
  {
    id: 8,
    bookImage: Quran_ibn_Amir,
    bookCaterory: "QUR'AN",
    bookTitle: "Qur'an -  Qirā’at Ibn Aamir",
    lessonNumber: "1",
    bookStudent: "205",
    bookPrice: 3000,
    ratings: 4.3,
    pdfUrl: "Quran_ibn_Aamir",
    fileName: ".pdf",
    curriculums: [
      {
        id: 1,
        show: false,
        outerText: "BUSINESS NAME CESSATION",
        innerText: [""],
      },
    ],
  },
  {
    id: 9,
    bookImage: Quran_hisham_ibn_Amir,
    bookCaterory: "QUR'AN",
    bookTitle: "Qur'an - Riwaayah Hisham",
    lessonNumber: "1",
    bookStudent: "205",
    bookPrice: 2000,
    ratings: 4.3,
    pdfUrl: "Quran_hisham_ibn_Aamir",
    fileName: ".pdf",
    curriculums: [
      {
        id: 1,
        show: false,
        outerText: "BUSINESS NAME CESSATION",
        innerText: [],
      },
    ],
  },
  {
    id: 10,
    bookImage: Quran_ibn_zakwan_ibn_aamir,
    bookCaterory: "QUR'AN",
    bookTitle: "Qur'an - Riwaayah Ibn Dhakwan",
    lessonNumber: "7",
    bookStudent: "227",
    bookPrice: 2000,
    ratings: 4.3,
    pdfUrl: "Quran_zakwan_ibn_Amir",
    fileName: ".pdf",
    curriculums: [
      {
        id: 1,
        show: false,
        outerText: "Intro Video: Introduction",
        innerText: [
          "Read Me: Consent Letter",
          "Lesson 1: How to do name search.",
          "Lesson 2: ",
          "Bonus 1: ",
          "Bonus 2:",
          "Bonus 3: ",
        ],
      },
    ],
  },
  {
    id: 11,
    bookImage: Quran_asim,
    bookCaterory: "QUR'AN",
    bookTitle: "Qur'an - Qirā’at Aasim",
    lessonNumber: "1",
    bookStudent: "10",
    bookPrice: 2000,
    ratings: 4.3,
    pdfUrl: "Quran_Aasim",
    fileName: ".pdf",
    curriculums: [
      {
        id: 1,
        show: false,
        outerText: "How to Resolve a Query on an Ngo Name During the  Stage",
        innerText: [
          "Video: How to Resolve a Query on an Ngo Name During the  Stage",
        ],
      },
    ],
  },
  {
    id: 12,
    bookImage: Quran_shubah_asimm,
    bookCaterory: "QUR'AN",
    bookTitle: "Qur'an - Riwaayah Shu’bah",
    lessonNumber: "1",
    bookStudent: "10",
    bookPrice: 1000,
    ratings: 4.3,
    pdfUrl: "Quran_Shubah_Asim",
    fileName: ".pdf",
    curriculums: [
      {
        id: 1,
        show: false,
        outerText: "How to Resolve a Query on an Ngo Name During the  Stage",
        innerText: [
          "Video: How to Resolve a Query on an Ngo Name During the  Stage",
        ],
      },
    ],
  },

  {
    id: 13,
    bookImage: Quran_Hamzat,
    bookCaterory: "QUR'AN",
    bookTitle: "Qur'an - Qirā’at Hamzah",
    lessonNumber: "1",
    bookStudent: "3",
    bookPrice: 3000,
    ratings: 4.5,
    pdfUrl: "Quran_Hamzah",
    fileName: ".pdf",
    curriculums: [
      {
        id: 1,
        show: false,
        outerText: "",
        innerText: [""],
      },
    ],
  },
  {
    id: 14,
    bookImage: Quran_khalaf_hamzahh,
    bookCaterory: "QUR'AN",
    bookTitle: "Qur'an - Riwaayah Khalaf",
    lessonNumber: "1",
    bookStudent: "3",
    bookPrice: 3000,
    ratings: 4.5,
    pdfUrl: "Quran_khalaf_Hamzah",
    fileName: ".pdf",
    curriculums: [
      {
        id: 1,
        show: false,
        outerText: "",
        innerText: [""],
      },
    ],
  },
  {
    id: 15,
    bookImage: quran_khalad_hamzah,
    bookCaterory: "QUR'AN",
    bookTitle: "Qur'an - Riwaayah Khallad",
    lessonNumber: "1",
    bookStudent: "5",
    bookPrice: 2000,
    ratings: 4.2,
    pdfUrl: "Quran_khalid_hamzah",
    fileName: ".pdf",
    curriculums: [
      {
        id: 1,
        show: false,
        outerText:
          "How to Edit or Alter the Object of Memorandum & Article of Association of a Company",
        innerText: [
          "How to Edit or Alter the Object of Memorandum & Article of Association of a Company",
        ],
      },
    ],
  },
  {
    id: 16,
    bookImage: Quran_kisahii,
    bookCaterory: "QUR'AN",
    bookTitle: "Qur'an - Qirā’at Al-Kisaa’i",
    lessonNumber: "1",
    bookStudent: "4",
    bookPrice: 3000,
    ratings: 3.2,
    pdfUrl: "Quran_kisahi",
    fileName: ".pdf",
    curriculums: [],
  },
  {
    id: 17,
    bookImage: Quran_jafar,
    bookCaterory: "QUR'AN",
    bookTitle: "Qur'an - Qirā’at Abu Ja‘far al-Madani",
    lessonNumber: "6",
    bookStudent: "121",
    bookPrice: 3000,
    ratings: 3.9,
    pdfUrl: "Quran_Abu_jafar",
    fileName: ".pdf",
    curriculums: [
      {
        id: 1,
        show: false,
        outerText:
          "PRACTICAL GUIDE TO PROCESS THE NIGERIA EXPORT LICENSE CERTIFICATE",
        innerText: [
          "Lesson 1: Introdcution",
          "Lesson 2: ",
          "Lesson 3: ",
          "Bonus 1: ",
        ],
      },
    ],
  },
  {
    id: 18,
    bookImage: Quran_yaakuub,
    bookCaterory: "QUR'AN",
    bookTitle: "Qur'an - Qirā’at Ya‘qub al-Hadrami",
    lessonNumber: "15",
    bookStudent: "202",
    bookPrice: 3000,
    ratings: 4.5,
    pdfUrl: "Quran_yaakub",
    fileName: ".pdf",
    curriculums: [
      {
        id: 1,
        show: false,
        outerText: "My Whatsapp Automation System Tools",
        innerText: [
          "Intro.",
          "Download, Launch & Setting up the Automation Apps.",
          "Overview of App (1) & How to use it.",
          "Closing Conclave",
        ],
      },
    ],
  },
  {
    id: 19,
    bookImage: Quran_khalaf_ashir,
    bookCaterory: "QUR'AN",
    bookTitle: "Qur'an - Qirā’at Khalaf al-‘Ashir",
    lessonNumber: "1",
    bookStudent: "200",
    bookPrice: 3000,
    ratings: 4.1,
    pdfUrl: "Quran_khalaf",
    fileName: ".pdf",
    curriculums: [],
  },
  {
    id: 20,
    bookImage: warsh_nafi,
    bookCaterory: "Key Principles of Qira’at",
    bookTitle: "Key Principle - Riwaayah Warsh",
    lessonNumber: "7",
    bookStudent: "200",
    bookPrice: 5000,
    ratings: 4.2,
    pdfUrl: "warsh_An_Nafiu",
    fileName: ".pdf",
    curriculums: [],
  },
  {
    id: 21,
    bookImage: qolun_nafi,
    bookCaterory: "Key Principles of Qira’at",
    bookTitle: "Key Principle - Riwaayah Qaloon",
    lessonNumber: "1",
    bookStudent: "205",
    bookPrice: 3000,
    ratings: 4.3,
    pdfUrl: "qolun_An_Nafiu",
    fileName: ".pdf",
    curriculums: [],
  },
  {
    id: 22,
    bookImage: ibn_kasirr,
    bookCaterory: "Key Principles of Qira’at",
    bookTitle: "Key Principle - Qirā’at Ibn Katheer al-Makki",
    lessonNumber: "15",
    bookStudent: "20",
    bookPrice: 4000,
    ratings: 4.3,
    pdfUrl: "Ibn_kasir",
    fileName: ".pdf",
    curriculums: [],
  },
  {
    id: 23,
    bookImage: doori,
    bookCaterory: "Key Principles of Qira’at",
    bookTitle: "Key Principle - Riwaayah Al-Doori",
    lessonNumber: "1",
    bookStudent: "10",
    bookPrice: 3500,
    ratings: 4.7,
    pdfUrl: "Doori_Abu_Amr",
    fileName: ".pdf",
    curriculums: [
      {
        id: 1,
        show: false,
        outerText: "Step By Step Video",
        innerText: ["How To Get Your Affiliate Link"],
      },
    ],
  },
  {
    id: 24,
    bookImage: soosi_abu_amr,
    bookCaterory: "Key Principles of Qira’at",
    bookTitle: "Key Principle - Riwaayah As-Sousi",
    lessonNumber: "12",
    bookStudent: "335",
    bookPrice: 4000,
    ratings: 4.5,
    pdfUrl: "Suusi_Abu_Amr",
    fileName: ".pdf",
    curriculums: [
      {
        id: 1,
        show: false,
        outerText: "eBOOK PUBLISHING book",
        innerText: [
          "PBM: Welcome intro",
          "PBM: Lesson 1 - Introduction",
          "PBM: Lesson 2- ",
          "PBM: Lesson 3 - ",
          "PBM: Lesson 4 - ",
          "PBM: Lesson 6 - ",
          "PBM: Lesson 7 - How to design the INSIDE of your eBook",
          "PBM: Lesson 8 - How to PUBLISH your eBook",
          "PBM: Lesson 9 - ",
          "PBM: Lesson 10 - ",
          "Free eBook Templets",
        ],
      },
    ],
  },
  {
    id: 25,
    bookImage: ibn_Aamirr,
    bookCaterory: "Key Principles of Qira’at",
    bookTitle: "Key Principle - Qirā’at Ibn Aamir ash-Shami",
    lessonNumber: "1",
    bookStudent: "5",
    bookPrice: 5000,
    ratings: 4.2,
    pdfUrl: "Ibnu_Aamir",
    fileName: ".pdf",
    curriculums: [],
  },
  {
    id: 26,
    bookImage: shubah_asimm,
    bookCaterory: "Key Principles of Qira’at",
    bookTitle: "Key Principle - Riwaayah Shu’bah",
    lessonNumber: "9",
    bookStudent: "432",
    bookPrice: 2000,
    ratings: 4.9,
    pdfUrl: "Shubah",
    fileName: ".pdf",
    curriculums: [],
  },
  {
    id: 27,
    bookImage: hamzahh,
    bookCaterory: "Key Principles of Qira’at",
    bookTitle: "Key Principle - Qirā’at Hamzah al-Zayyat",
    lessonNumber: "8",
    bookStudent: "291",
    bookPrice: 7000,
    ratings: 4.9,
    pdfUrl: "hamzah",
    fileName: ".pdf",
    curriculums: [],
  },
  {
    id: 28,
    bookImage: kisahii,
    bookCaterory: "Key Principles of Qira’at",
    bookTitle: "Key Principle - Qirā’at Al-Kisaa’i",
    lessonNumber: "48",
    bookStudent: "",
    bookPrice: 4500,
    ratings: 4.1,
    pdfUrl: "kisahi",
    fileName: ".pdf",
    curriculums: [
      {
        id: 1,
        show: false,
        outerText: "COMPANY POST-QUR'AN",
        innerText: ["", ""],
      },
    ],
  },
  {
    id: 29,
    bookImage: jafar,
    bookCaterory: "Key Principles of Qira’at",
    bookTitle: "Key Principle - Qirā’at Abu Ja‘far al-Madani",
    lessonNumber: "7",
    bookStudent: "200",
    bookPrice: 9000,
    ratings: 4.2,
    pdfUrl: "Abu_jafar",
    fileName: ".pdf",
    curriculums: [
      {
        id: 1,
        show: false,
        outerText: "NGO POST-QUR'AN",
        innerText: [],
      },
    ],
  },
  {
    id: 30,
    bookImage: yaakuub,
    bookCaterory: "Key Principles of Qira’at",
    bookTitle: "Key Principle - Qirā’at Ya‘qub al-Hadrami",
    lessonNumber: "7",
    bookStudent: "200",
    bookPrice: 10000,
    ratings: 4.2,
    pdfUrl: "yaakub",
    fileName: ".pdf",
    curriculums: [
      {
        id: 1,
        show: false,
        outerText: "NGO POST-QUR'AN",
        innerText: [],
      },
    ],
  },
  {
    id: 31,
    bookImage: khalaf_ashirr,
    bookCaterory: "Key Principles of Qira’at",
    bookTitle: "Key Principle - Qirā’at Khalaf al-‘Ashir",
    lessonNumber: "7",
    bookStudent: "200",
    bookPrice: 9500,
    ratings: 4.2,
    pdfUrl: "khalaful_Ashir",
    fileName: ".pdf",
    curriculums: [
      {
        id: 1,
        show: false,
        outerText: "NGO POST-QUR'AN",
        innerText: [],
      },
    ],
  },
  {
    id: 32,
    bookImage: Qohidat_Nour_El_Bayan,
    bookCaterory: "Learning Tools",
    bookTitle: "Learning Tool - Nour El Bayan",
    lessonNumber: "7",
    bookStudent: "200",
    bookPrice: 1000,
    ratings: 4.2,
    pdfUrl: "Nour_El_Bayan",
    fileName: ".pdf",
    curriculums: [
      {
        id: 1,
        show: false,
        outerText: "QUR'AN",
        innerText: [""],
      },
    ],
  },
  {
    id: 33,
    bookImage: Qohidat_Nour_El_Bayan,
    bookCaterory: "Learning Tools",
    bookTitle: "Learning Tool - Nour El Bayan",
    lessonNumber: "7",
    bookStudent: "200",
    bookPrice: 1000,
    ratings: 4.2,
    pdfUrl: "Nour_El_Bayan",
    fileName: ".pdf",
    curriculums: [
      {
        id: 1,
        show: false,
        outerText: "NGO POST-QUR'AN",
        innerText: [],
      },
    ],
  },
  {
    id: 34,
    bookImage: Quran_hafs_aasim,
    bookCaterory: "QUR'AN",
    bookTitle: "Qur'an - Riwaayah Hafs",
    lessonNumber: "1",
    bookStudent: "10",
    bookPrice: 1000,
    ratings: 4.3,
    pdfUrl: "Quran_hafs_Aasim",
    fileName: ".pdf",
    curriculums: [
      {
        id: 1,
        show: false,
        outerText: "How to Resolve a Query on an Ngo Name During the  Stage",
        innerText: [
          "Video: How to Resolve a Query on an Ngo Name During the  Stage",
        ],
      },
    ],
  },
];

const QIRAAT_RIWAYAT = [
  {
    id: 1,
    name: "Shu'bah 'an 'Asim",
    description: "One of the canonical transmissions from 'Asim",
    paymentOptions: [
      {
        type: "monthly",
        nigeriaPrice: 5000,
        diasporaPrice: 15,
        label: "Monthly Plan",
      },
      {
        type: "full",
        nigeriaPrice: 50000,
        diasporaPrice: 150,
        label: "Full Course (One-time Payment)",
      },
    ],
  },
  {
    id: 2,
    name: "Warsh 'an Nafi'",
    description: "Widespread in North and West Africa",
    paymentOptions: [
      {
        type: "monthly",
        nigeriaPrice: 10000,
        diasporaPrice: 30,
        label: "Monthly Plan",
      },
      {
        type: "full",
        nigeriaPrice: 100000,
        diasporaPrice: 300,
        label: "Full Course (One-time Payment)",
      },
    ],
  },
  {
    id: 3,
    name: "Khalaf 'an Hamzah",
    description: "Canonical transmissions from Hamzah",
    paymentOptions: [
      {
        type: "monthly",
        nigeriaPrice: 10000,
        diasporaPrice: 30,
        label: "Monthly Plan",
      },
      {
        type: "full",
        nigeriaPrice: 100000,
        diasporaPrice: 300,
        label: "Full Course (One-time Payment)",
      },
    ],
  },
  {
    id: 4,
    name: "Khallad 'an Hamzah",
    description: "Another canonical transmission from Hamzah",
    paymentOptions: [
      {
        type: "monthly",
        nigeriaPrice: 10000,
        diasporaPrice: 30,
        label: "Monthly Plan",
      },
      {
        type: "full",
        nigeriaPrice: 100000,
        diasporaPrice: 300,
        label: "Full Course (One-time Payment)",
      },
    ],
  },
  {
    id: 5,
    name: "Qalun 'an Nafi'",
    description: "Common in Libya and parts of Tunisia",
    paymentOptions: [
      {
        type: "monthly",
        nigeriaPrice: 7000,
        diasporaPrice: 20,
        label: "Monthly Plan",
      },
      {
        type: "full",
        nigeriaPrice: 70000,
        diasporaPrice: 200,
        label: "Full Course (One-time Payment)",
      },
    ],
  },
  {
    id: 6,
    name: "Al-Duri 'an Abu 'Amr",
    description: "Found in parts of Sudan and West Africa",
    paymentOptions: [
      {
        type: "monthly",
        nigeriaPrice: 7000,
        diasporaPrice: 20,
        label: "Monthly Plan",
      },
      {
        type: "full",
        nigeriaPrice: 70000,
        diasporaPrice: 200,
        label: "Full Course (One-time Payment)",
      },
    ],
  },
  {
    id: 7,
    name: "Al-Susi 'an Abu 'Amr",
    description: "Historical recitation method",
    paymentOptions: [
      {
        type: "monthly",
        nigeriaPrice: 7000,
        diasporaPrice: 20,
        label: "Monthly Plan",
      },
      {
        type: "full",
        nigeriaPrice: 70000,
        diasporaPrice: 200,
        label: "Full Course (One-time Payment)",
      },
    ],
  },
  {
    id: 8,
    name: "Qubool 'an Ibn Kathir al-Makki",
    description: "Historical Meccan reading",
    paymentOptions: [
      {
        type: "monthly",
        nigeriaPrice: 7000,
        diasporaPrice: 20,
        label: "Monthly Plan",
      },
      {
        type: "full",
        nigeriaPrice: 70000,
        diasporaPrice: 200,
        label: "Full Course (One-time Payment)",
      },
    ],
  },
  {
    id: 9,
    name: "Hisham 'an Ibn 'Amir",
    description: "Associated with Damascus",
    paymentOptions: [
      {
        type: "monthly",
        nigeriaPrice: 7000,
        diasporaPrice: 20,
        label: "Monthly Plan",
      },
      {
        type: "full",
        nigeriaPrice: 70000,
        diasporaPrice: 200,
        label: "Full Course (One-time Payment)",
      },
    ],
  },
  {
    id: 10,
    name: "Ibn Dhakwan 'an Ibn 'Amir",
    description: "Syrian tradition",
    paymentOptions: [
      {
        type: "monthly",
        nigeriaPrice: 7000,
        diasporaPrice: 20,
        label: "Monthly Plan",
      },
      {
        type: "full",
        nigeriaPrice: 70000,
        diasporaPrice: 200,
        label: "Full Course (One-time Payment)",
      },
    ],
  },
  {
    id: 11,
    name: "Al-Duri 'an Kisa'i ",
    description: "The most common reading worldwide today",
    paymentOptions: [
      {
        type: "monthly",
        nigeriaPrice: 7000,
        diasporaPrice: 20,
        label: "Monthly Plan",
      },
      {
        type: "full",
        nigeriaPrice: 70000,
        diasporaPrice: 200,
        label: "Full Course (One-time Payment)",
      },
    ],
  },
  {
    id: 12,
    name: "Al-DuriAbu lais 'an Kisa'i ",
    description: "One of the Ten Readers",
    paymentOptions: [
      {
        type: "monthly",
        nigeriaPrice: 7000,
        diasporaPrice: 20,
        label: "Monthly Plan",
      },
      {
        type: "full",
        nigeriaPrice: 70000,
        diasporaPrice: 200,
        label: "Full Course (One-time Payment)",
      },
    ],
  },
  {
    id: 13,
    name: "Ibn Wardan 'an Abu Ja'far",
    description: "From the Ten Readers tradition",
    paymentOptions: [
      {
        type: "monthly",
        nigeriaPrice: 7000,
        diasporaPrice: 20,
        label: "Monthly Plan",
      },
      {
        type: "full",
        nigeriaPrice: 70000,
        diasporaPrice: 200,
        label: "Full Course (One-time Payment)",
      },
    ],
  },
  {
    id: 14,
    name: "Ibn Jammaz 'an Abu Ja'far",
    description: "Another narration from Abu Ja'far",
    paymentOptions: [
      {
        type: "monthly",
        nigeriaPrice: 7000,
        diasporaPrice: 20,
        label: "Monthly Plan",
      },
      {
        type: "full",
        nigeriaPrice: 70000,
        diasporaPrice: 200,
        label: "Full Course (One-time Payment)",
      },
    ],
  },
  {
    id: 15,
    name: "Rawh 'an Ya'qub",
    description: "From the Ten Readers tradition",
    paymentOptions: [
      {
        type: "monthly",
        nigeriaPrice: 7000,
        diasporaPrice: 20,
        label: "Monthly Plan",
      },
      {
        type: "full",
        nigeriaPrice: 70000,
        diasporaPrice: 200,
        label: "Full Course (One-time Payment)",
      },
    ],
  },
  {
    id: 16,
    name: "Ruways 'an Ya'qub",
    description: "Another narration from Ya'qub",
    paymentOptions: [
      {
        type: "monthly",
        nigeriaPrice: 7000,
        diasporaPrice: 20,
        label: "Monthly Plan",
      },
      {
        type: "full",
        nigeriaPrice: 70000,
        diasporaPrice: 200,
        label: "Full Course (One-time Payment)",
      },
    ],
  },
  {
    id: 17,
    name: "Ishaq 'an Khalaf al-Bazzar",
    description: "Less commonly practiced today",
    paymentOptions: [
      {
        type: "monthly",
        nigeriaPrice: 7000,
        diasporaPrice: 20,
        label: "Monthly Plan",
      },
      {
        type: "full",
        nigeriaPrice: 70000,
        diasporaPrice: 200,
        label: "Full Course (One-time Payment)",
      },
    ],
  },
  {
    id: 18,
    name: "Idris 'an Khalaf al-Bazzar",
    description: "Another narration from Khalaf",
    paymentOptions: [
      {
        type: "monthly",
        nigeriaPrice: 7000,
        diasporaPrice: 20,
        label: "Monthly Plan",
      },
      {
        type: "full",
        nigeriaPrice: 70000,
        diasporaPrice: 200,
        label: "Full Course (One-time Payment)",
      },
    ],
  },
  {
    id: 19,
    name: "Bazi' 'an Ibn Kathir al-Makki",
    description: "Historical Meccan reading",
    paymentOptions: [
      {
        type: "monthly",
        nigeriaPrice: 7000,
        diasporaPrice: 20,
        label: "Monthly Plan",
      },
      {
        type: "full",
        nigeriaPrice: 70000,
        diasporaPrice: 200,
        label: "Full Course (One-time Payment)",
      },
    ],
  },
  {
    id: 20,
    name: "Al-Isfahani 'an Warsh 'an Nafi'",
    description: "A sub-transmission of Warsh",
    paymentOptions: [
      {
        type: "monthly",
        nigeriaPrice: 7000,
        diasporaPrice: 20,
        label: "Monthly Plan",
      },
      {
        type: "full",
        nigeriaPrice: 70000,
        diasporaPrice: 200,
        label: "Full Course (One-time Payment)",
      },
    ],
  },
];
const AVAILABLE_COURSES = [
  {
    id: 1,
    name: "Qaidah",
    description: "From beginner to advanced-level reading proficiency.",
    paymentOptions: [
      {
        type: "monthly",
        nigeriaPrice: 5000,
        diasporaPrice: 15,
        label: "Monthly Plan",
      },
    ],
  },
  {
    id: 2,
    name: "Quran Memorization & Recitation",
    description: "Structured learning for memorizing and perfecting Tajweed.",
    paymentOptions: [
      {
        type: "monthly",
        nigeriaPrice: 10000,
        diasporaPrice: 30,
        label: "Monthly Plan",
      },
    ],
  },
  {
    id: 3,
    name: "Qira'at (Advanced Quranic Recitation)",
    description:
      "Exclusively for Hufaaz who wish to master multiple recitation styles.",
    requiresHafiz: true,
    hasRiwayatOptions: true, // New property to indicate this course has riwayat options
    paymentOptions: [
      {
        type: "monthly",
        nigeriaPrice: 7000, // Default price if no specific riwayat is selected
        diasporaPrice: 20,
        label: "Monthly Plan",
      },
      {
        type: "full",
        nigeriaPrice: 70000, // Default price if no specific riwayat is selected
        diasporaPrice: 200,
        label: "Full Course (One-time Payment)",
      },
    ],
  },
];
const bookHeaders = ["Overview", "Curriculum", "Instructor", "Reviews"];
export {
  slides,
  instructors,
  awards,
  contents,
  cardInfos,
  bookHeaders,
  curriculums,
  QIRAAT_RIWAYAT,
  AVAILABLE_COURSES,
};
